module.exports = __webpack_public_path__ + "img/firma-daniel.b6fca007.png";